import React from 'react';
import location from "../../../assets/photos/4th.jpg"; // Make sure to replace this with the correct path to your image

const Location = () => {
  return (
    <div>
      {/* Main Content */}
      <div className="flex flex-wrap lg:flex-nowrap w-full bg-gray-100">
        {/* Left Section: Image */}
        <div className="w-full lg:w-1/2">
          <img
            src={location}
            alt="Students at CodeQueue"
            className="w-full h-[300px] lg:h-[calc(100vh-64px)] object-cover"
          />
        </div>

        {/* Right Section: Centered Text */}
        <div className="w-full lg:w-1/2 flex flex-col justify-center px-6 lg:px-20 py-6">
          
          <h1 className="text-3xl lg:text-5xl font-semibold text-blue-900 mb-4">
          	Working all over the India 
          </h1>
          <p className="text-blue-900 text-base lg:text-lg leading-relaxed py-4 mb-6">
          	We are at home everywhere. <span className='font-bold'>Our presence offers opportunities</span> to work with colleagues from diverse backgrounds and locations around the India.
          </p>
          <button className="bg-black text-white px-4 py-3 rounded hover:bg-gray-800 transition duration-300">
          Explore our locations
          </button>
        </div>
      </div>
    </div>
  );
};

export default Location;
